import { Building2, HardHat } from "lucide-react";

import { BtpDashboardPage } from "./pages/BtpDashboardPage";
import { ChantierDetailPage } from "./pages/ChantierDetailPage";
import { ChantiersPage } from "./pages/ChantiersPage";
import { DevisPage } from "./pages/DevisPage";
import { BtpProfilesPage } from "./pages/BtpProfilesPage";
import type { FrontendModule } from "../types";

export const btpModule: FrontendModule = {
  id: "btp",
  backendCodes: ["BTP"],
  nav: [
    { to: "/btp/devis", label: "Devis BTP", icon: Building2, section: "metiers" },
    { to: "/btp/profils", label: "Profils BTP", icon: HardHat, section: "metiers" },
    { to: "/btp", label: "BTP", icon: HardHat, end: true, section: "metiers" },
    { to: "/btp/chantiers", label: "Chantiers", icon: Building2, section: "metiers" },
  ],
  routes: [
    { path: "btp/devis", element: <DevisPage /> },
    { path: "btp/profils", element: <BtpProfilesPage /> },
    { path: "btp", element: <BtpDashboardPage /> },
    { path: "btp/chantiers", element: <ChantiersPage /> },
    { path: "btp/chantiers/:chantierId", element: <ChantierDetailPage /> },
  ],
};
